export default class SavingTip {
	constructor() {
		this.buttons = document.getElementsByClassName('savetiped');
		this.savetips = [];
		let i = 0;
		for (const button of this.buttons) {
			button.index = i;
			const div = document.createElement('div');
			div.classList.add('savetip');
			div.textContent = button.dataset.savetip;
			this.savetips.push({ savetip: div, target: button });
			document.body.appendChild(div);
			i++;
		}
	}

	hideSaveTip(index) {
		this.savetips[index].savetip.classList.remove('shown');
	}

	showSaveTip(index) {
		console.log('show saving tip');

		const targetPosition = this.savetips[index].target.getBoundingClientRect();
		const targetWidth = this.savetips[index].target.offsetWidth;
		const targetHeight = this.savetips[index].target.offsetHeight;
		const topOffset = this.savetips[index].savetip.classList.contains('tooltip-right') ? targetHeight / 2 : -30;
		const leftOffset = this.savetips[index].savetip.classList.contains('tooltip-right')
			? targetWidth + 10
			: targetWidth / 2;
		this.savetips[index].savetip.style.top = `${Math.round(targetPosition.top + topOffset)}px`;
		this.savetips[index].savetip.style.left = `${Math.round(targetPosition.left + leftOffset)}px`;
		this.savetips[index].savetip.classList.add('shown');
	}

	show(index) {
		if (this.showTimeout) clearTimeout(this.showTimeout);
		this.showSaveTip(index);
		this.showTimeout = setTimeout(() => {
			this.hideSaveTip(index);
		}, 1000);
	}
}
